import { RequestError } from '../api/http-client';
import { UNKNOWN_ERROR } from '../constants/messages';

export const getErrorMessage = (error: RequestError | null): string => error?.response?.__error__ ?? UNKNOWN_ERROR;
